import * as React from 'react';
import * as i18next from 'i18next';
import { useTranslation } from 'react-i18next';

import Checkbox from 'crehana-ui/Checkbox';

import localeEs from 'Jsx/MainMenu/locales/es';

export const rulesForRHFControllerComponent = (t: i18next.TFunction) => ({
  required: {
    value: true,
    message: t('AUTH_VALIDATION_LEGALS_REQUIRED', {
      defaultValue: localeEs.es.translation.AUTH_VALIDATION_LEGALS_REQUIRED,
    }),
  },
});

export const LegalErrorMessage: React.FC<{ message: string }> = ({
  message,
}) => (
  <span className="font-legals text-red-main block mt-4" role="alert">
    {message}
  </span>
);

const LegalCheckbox: React.FC<{
  onChange(value: any): void;
  onBlur: React.DOMAttributes<HTMLInputElement>['onBlur'];
  value?: boolean;
}> = ({ onBlur, onChange, value }) => {
  const { t } = useTranslation();

  return (
    <Checkbox
      small
      label={
        <React.Fragment>
          {t('LEGALS_TEXT_1', {
            defaultValue: localeEs.es.translation.LEGALS_TEXT_1,
          })}
          <a
            href="/legal/"
            target="_blank"
            className="font-caption text-gray-dark hover:text-secondary-main"
            style={{
              textDecoration: 'none',
            }}
          >
            {t('LEGALS_TEXT_2', {
              defaultValue: localeEs.es.translation.LEGALS_TEXT_2,
            })}
          </a>
          de Crehana.
        </React.Fragment>
      }
      onChange={event => {
        const { checked } = event.target;

        onChange(!checked);
      }}
      onBlur={onBlur}
      checked={value}
    />
  );
};

export default LegalCheckbox;
